import { offerAssesmentValue } from "@components/ui/offer-assesment/types/offerAssesmentValue"
interface BuildOfferAssesmentPropsParams {
    uuid: string;
    offer: string | number;
    items: any[];
}
export const buildOfferAssesmentProps = ({
    uuid,
    offer,
    items
}: BuildOfferAssesmentPropsParams) => {
    return {
        "uuid": uuid,
        [offerAssesmentValue.group]: {
            [offerAssesmentValue.subGroup.information]: {
                [offerAssesmentValue.field.uuid]: uuid,
                [offerAssesmentValue.field.offer]: offer,
                [offerAssesmentValue.field.items]: items,
            }
        }
    }
}